import config from '@/configs'
import { MENU_SECTION_IDS, SERVICE_IDS, TOOL_ITEM_IDS } from '@/constants/services'
import {
  hasCampaignService,
  hasService,
  hasWhatsappOrChat
} from '@/utils/hasService'

function cloneMenu(menu) {
  return JSON.parse(JSON.stringify(menu))
}

function filterMenuSectionItems(section, predicate) {
  if (!section?.items) {
    return section
  }
  return {
    ...section,
    items: section.items.filter(predicate)
  }
}

export function buildMenuForUser({
  roleId = -1,
  userId = -1,
  services = [],
  isOwner = false,
  isSupervisor = false,
  isAgent = false
} = {}) {
  let menu = cloneMenu(config.navigation.menu)

  if (roleId !== 1) {
    menu = menu.filter((section) => section.sectionId !== MENU_SECTION_IDS.CHANNELS && section.sectionId !== MENU_SECTION_IDS.OTHERS)
  }

  if (!hasCampaignService(services)) {
    menu = menu.filter((section) => section.sectionId !== MENU_SECTION_IDS.CAMPAIGNS)
  }

  if (!hasService(services, SERVICE_IDS.CHAT) || (!isOwner && !isSupervisor)) {
    menu = menu.filter((section) => section.sectionId !== MENU_SECTION_IDS.CUSTOMER_CARE)
  } else if (!isOwner || !isSupervisor) {
    menu = menu.map((section) => {
      if (section.sectionId !== MENU_SECTION_IDS.CUSTOMER_CARE) {
        return section
      }
      return {
        ...section,
        items: section.items.map((item) => {
          if (!item.items) {
            return item
          }
          return {
            ...item,
            items: item.items.filter((subItem) => {
              if (!isOwner && subItem.link === '/management/workgroups') {
                return false
              }
              if (!isSupervisor && subItem.link === '/management/supervisor') {
                return false
              }
              return true
            })
          }
        })
      }
    })
  }

  if (!hasService(services, SERVICE_IDS.CHAT) || !isAgent) {
    menu = menu.filter((section) => section.sectionId !== MENU_SECTION_IDS.CHAT)
  }

  if (!hasWhatsappOrChat(services)) {
    menu = menu.map((section) => {
      if (section.sectionId !== MENU_SECTION_IDS.TOOLS) {
        return section
      }
      return filterMenuSectionItems(section, (item) => item.itemId !== TOOL_ITEM_IDS.BLACKLIST)
    })
  }

  if (userId !== 1) {
    menu = menu.filter((section) => section.sectionId !== MENU_SECTION_IDS.SUPPORT)
  }

  return menu
}
